import {
  dimensiondata_1_tetelek_group_w200_dimension_1_2_3_row,
  TJ_value_1_data_precision,
  year_column,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesHoMerlegConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: true,
  filterYear: {numberOfYears: 12},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesHoMerleg',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_dimension_1_2_3_row,
      year_column,
      TJ_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
